export const AUTH_START = 'AUTH_START' as const;
export const AUTH_SUCCESS = 'AUTH_SUCCESS' as const;
export const AUTH_FAIL = 'AUTH_FAIL' as const;
export const AUTH_LOGOUT = 'AUTH_LOGOUT' as const;
export const START_LOADING_USER_PROFILE = 'START_LOADING_USER_PROFILE' as const;
export const USER_PROFILE_LOADED = 'USER_PROFILE_LOADED' as const;
export const UPDATE_USER_SUCCESSFULLY = 'UPDATE_USER_SUCCESSFULLY' as const;

export const CHANGE_CURRENT_COMPANY = 'CHANGE_CURRENT_COMPANY' as const;

export const REFRESH_CONNECTION_SUCCESS = 'REFRESH_CONNECTION_SUCCESS' as const;

export const REGISTRATION_START = 'REGISTRATION_START' as const;
export const REGISTRATION_SUCC = 'REGISTRATION_SUCC' as const;
export const REGISTRATION_FAIL = 'REGISTRATION_FAIL' as const;
export const REGISTRATION_CONFIRM = 'REGISTRATION_CONFIRM' as const;

export const START_LOADING_CONSIST_DOORS = 'START_LOADING_CONSSIST_DOORS' as const;
export const LOAD_CONSIST = 'LOAD_CONSIST' as const;
export const SUCCESS_CONSIST = 'SUCCESS_CONSIST' as const;
export const SUCCESS_BUILD_ITEM = 'SUCCESS_BUILD_ITEM' as const;
export const CONSIST_FAIL = 'CONSIST_FAIL' as const;
export const ON_PATCH_SUCCESS = 'ON_PATCH_SUCCESS' as const;
export const SUCCESS_PROPERTY = 'SUCCESS_PROPERTY' as const;
export const SUCCESS_COMPONENTS = 'SUCCESS_COMPONENTS' as const;
export const SUCCESS_COLORS = 'SUCCESS_COLORS' as const;
export const SUCCESS_SOLUTIONS = 'SUCCESS_SOLUTIONS' as const;
export const SUCCESS_CREATED_PROPERTY = 'SUCCESS_CREATED_PROPERTY' as const;
export const SUCCESS_PROPERTY_DELETE = 'SUCCESS_PROPERTY_DELETE' as const;
export const SUCCESS_PROPERTY_EDITED = 'SUCCESS_PROPERTY_EDITED' as const;

export const SUCCESS_PROPERTYINSIDE_EDITED = 'SUCCESS_PROPERTYINSIDE_EDITED' as const;
export const SUCCESS_ADDED_PROPERTY_SET = 'SUCCESS_ADDED_PROPERTY_SET' as const;

export const SUCCESS_CREATED_COMPONENT = 'SUCCESS_CREATED_COMPONENT' as const;
export const SUCCESS_DELETED_COMPONENT = 'SUCCESS_DELETED_COMPONENT' as const;
export const SUCCESS_UPDATED_COMPONENT_COLOR = 'SUCCESS_UPDATED_COMPONENT_COLOR' as const;

export const SUCCESS_CLASSIFICATION = 'SUCCESS_CLASSIFICATION' as const;

export const SET_ID_ROUTE = 'SET_ID_ROUTE' as const;

export const SUCCESS_GEO = 'SUCCESS_GEO' as const;

export const REHYDRATE = 'persist/REHYDRATE' as const;

export const SET_PAGE_PERMISSION = 'SET_PAGE_PERMISSION' as const;

export const ADD_CONTRACT = 'ADD_CONTRACT' as const;
export const REMOVE_CONTRACT = 'REMOVE_CONTRACT' as const;
export const UPDATE_CONTRACT = 'UPDATE_CONTRACT' as const;

export const NOTIFICATIONS_SNAPSHOT = 'NOTIFICATIONS_SNAPSHOT' as const;
export const NOTIFICATIONS_SET = 'NOTIFICATIONS_SET' as const;
export const NOTIFICATION_ADDED = 'NOTIFICATION_ADDED' as const;
export const NOTIFICATION_MARKED_READ = 'NOTIFICATION_MARKED_READ' as const;
export const NOTIFICATIONS_ALL_READ = 'NOTIFICATIONS_ALL_READ' as const;
export const NOTIFICATION_REMOVED = 'NOTIFICATION_REMOVED' as const;
export const NOTIFICATIONS_SET_UNREAD_COUNT = 'NOTIFICATIONS_SET_UNREAD_COUNT' as const;
export const NOTIFICATIONS_SET_CONNECTION = 'NOTIFICATIONS_SET_CONNECTION' as const;
export const NOTIFICATIONS_LOADING = 'NOTIFICATIONS_LOADING' as const;
